var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "12px",
    viewBox: "0 0 42 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.265336 0 0 0 0 0.265336 0 0 0 0 0.265336 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(-14.077279, -29.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.753111, 29.506223)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 5.53241678,
    cy: 5.53241678,
    r: 5.53241678
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#D8D8D8",
    cx: 20.2855282,
    cy: 5.53241678,
    r: 5.53241678
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#D8D8D8",
    cx: 35.0386396,
    cy: 5.53241678,
    r: 5.53241678
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDots);
export default __webpack_public_path__ + "static/media/action-dots.df37905b50b330299d845bf1effca67a.svg";
export { ForwardRef as ReactComponent };